export function wireIglesiaAutofill(select, { pastorInput, telefonoInput, nombreLibreInput, nombreLibreWrapper } = {}) {
    function apply() {
        const opt = select.options[select.selectedIndex];
        const isFreeText = !opt || opt.value === '';

        if (isFreeText) {
            if (pastorInput) {
                pastorInput.value = '';
                pastorInput.removeAttribute('readonly');
                pastorInput.classList.remove('success');
                pastorInput.removeAttribute('data-valid');
            }
            if (telefonoInput) {
                telefonoInput.value = '';
                telefonoInput.removeAttribute('readonly');
                telefonoInput.classList.remove('success');
                telefonoInput.removeAttribute('data-valid');
            }
            if (nombreLibreInput) {
                nombreLibreInput.value = '';
                nombreLibreInput.removeAttribute('disabled');
                nombreLibreInput.setAttribute('data-required', '');
                nombreLibreInput.classList.add('required');
            }
            if (nombreLibreWrapper) nombreLibreWrapper.hidden = false;
            return;
        }

        if (pastorInput) {
            pastorInput.value = opt.dataset.pastor || '';
            pastorInput.setAttribute('readonly', '');
            pastorInput.classList.remove('required');
            pastorInput.classList.add('success');
            pastorInput.setAttribute('data-valid', 'true');
        }
        if (telefonoInput) {
            telefonoInput.value = opt.dataset.telefono || '';
            telefonoInput.setAttribute('readonly', '');
            telefonoInput.classList.remove('required');
            telefonoInput.classList.add('success');
            telefonoInput.setAttribute('data-valid', 'true');
        }
        if (nombreLibreInput) {
            // The backend (Registro::store / Matricula::store) always expects
            // ceci_iglesia_nombre to be non-empty when "otra iglesia" is on,
            // even when an existing church was picked from the list — the
            // legacy ul/li implementation filled this same field with the
            // church's name in that case too. Keep it *enabled* (not
            // `disabled`) so FormData still submits it; only the wrapper is
            // hidden, matching how the old UI kept a single visible input.
            nombreLibreInput.value = opt.textContent.trim();
            nombreLibreInput.removeAttribute('disabled');
            nombreLibreInput.removeAttribute('data-required');
            nombreLibreInput.classList.remove('required');
            nombreLibreInput.setAttribute('data-valid', 'true');
        }
        if (nombreLibreWrapper) nombreLibreWrapper.hidden = true;
    }

    // Intentionally not calling apply() on setup: the fields involved start in
    // whatever disabled/hidden state the page renders them in (e.g. behind an
    // "otra iglesia" checkbox), and the placeholder option being selected by
    // default at load time must not force free-text mode to reveal itself.
    // apply() only runs on a genuine 'change' — user interaction, or a
    // programmatic dispatch (e.g. after hydrating by cédula).
    select.addEventListener('change', apply);
}
